<script>
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants';

  let { dataTestId = 'blog-breadcrumbs-list', crumbs, currentPage } = $props();
</script>

{#if crumbs || currentPage}
  <div
    data-testid={dataTestId}
    class="print:hidden w-full text-blue-navy overflow-x-auto whitespace-nowrap bg-gray-pale"
  >
    <ol class="px-1 w-full max-w-6xl mx-auto flex items-center" itemscope itemtype="https://schema.org/BreadcrumbList">
      {#if crumbs}
        {#each crumbs as crumb, i}
          <li class="flex items-center" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
            <BaseLink
              {...crumb}
              itemprop="item"
              className="py-3 px-2 md:px-3 md:py-4 font-medium text-base text-blue-cerulean hover-hover:hover:underline hover-hover:hover:text-blue-darkish active:underline active:text-blue-darkish"
              dataTestId="{dataTestId}-item"
            >
              <span itemprop="name">{crumb.text}</span>
            </BaseLink>
            {#if i !== crumbs.length - 1 || currentPage}
              <svg class="w-5 h-5 fill-current flex-none">
                <use xlink:href={`${SPRITESHEET_URL}#chevron-right`} />
              </svg>
            {/if}
            <meta itemprop="position" content={i + 1} />
          </li>
        {/each}
      {/if}
      {#if currentPage}
        <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <span class="text-base mx-2 md:mx-3" data-testid="{dataTestId}-current-page" itemprop="name"
            >{currentPage}</span
          >
          <meta itemprop="position" content={crumbs.length + 1} />
        </li>
      {/if}
    </ol>
  </div>
{/if}
